import React, { useState,useEffect } from "react";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import BreadCrumb from "./Components/BreadCrumb/BreadCrumb";
import  HomeAPI  from "../../api/homeApi";
import { useTranslation } from "react-i18next";


const PrivacyPolicy = () => {
    const { t } = useTranslation("privacy");
  
    
  
  
    const [SettingData, setSettingData] = useState(null);
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const data = await HomeAPI.gettermsData();
  
          setSettingData(data);
  
        } catch (error) {
          console.error("Error fetching home data:", error);
        }
      };
  
      fetchData();
    }, []);
  
  
  
    return (
      <>
        <HelmetInfo titlePage={"الاسئلة الشائعة"} />
        <div className="mt-[150px]" />
        <div className="main-container bg-[#fff] mx-auto px-4 py-8">
          {/* Header Section */}
          <div className="flex flex-col items-center justify-center gap-10 max-w-screen-lg mx-auto ">
            {/* Breadcrumb */}
            <BreadCrumb SettingData={SettingData}/>
            {/* Title Section */}
            <div className="text-center flex justify-center items-center flex-col gap-4">
              <h1 className="text-4xl lg:text-[2.7rem] text_bold_Bukra text-[#0d6b70] leading-[80px]">
            {SettingData?.data?.sections[0]?.title}
              </h1>
              {/* <p className="text-lg lg:text-[1.08rem] text-center text_small_Bukra  text-[#0d6b70] leading-relaxed md:px-[3.75rem] xl:w-[65%] mx-auto ">
                نحرص على توفير إجابات واضحة لأكثر الأسئلة شيوعاً حول خدماتنا، لتسهيل
                تجربتك وضمان فهمك الكامل لكل خطوة.
              </p> */}
            </div>
          </div>
                <div className="text-lg lg:text-[1.08rem] text_small_Bukra  text-[#667680] leading-relaxed md:px-[3.75rem] xl:w-[100%] mt-16" dangerouslySetInnerHTML={{
    __html: SettingData?.data?.sections[0]?.Posts[0]?.description || "",
  }}></div>

        </div>
      </>
    );
  };
  
  export default PrivacyPolicy;
  